import { endOfMinute, startOfMinute } from "date-fns";
import { Ref, onBeforeUnmount, onMounted, provide, ref } from "vue";
import useVisibilityChange from "./useVisibilityChange";

export const NowInjectionKey = Symbol("Now");

export default function useLiveTime () {
  const now = ref(startOfMinute(new Date));

  let timeoutId: NodeJS.Timeout;
  let intervalId: NodeJS.Timeout;

  provide<Ref<Date>>(NowInjectionKey, now);
  useVisibilityChange(handleVisibilityChange);

  onMounted(() => {
    restartInterval();
  });

  onBeforeUnmount(() => {
    stopInterval();
  });

  function handleVisibilityChange (isAppVisible: boolean) {
    if (isAppVisible) {
      updateTime();
      restartInterval();
    } else {
      stopInterval();
    }
  }

  function updateTime () {
    now.value = startOfMinute(new Date);
  }

  function restartInterval () {
    const millisecondsUntilNextMinute = endOfMinute(new Date()).getTime() - new Date().getTime() + 1;

    stopInterval();
    timeoutId = setTimeout(() => {
      updateTime();
      intervalId = setInterval(updateTime, 1000 * 60);
    }, millisecondsUntilNextMinute);
  }

  function stopInterval () {
    clearTimeout(timeoutId);
    clearInterval(intervalId);
  }

  return {
    now,
  };
}
